"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssociatedTokenAccount = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const buffer_1 = require("buffer");
class CreateAssociatedTokenAccount extends web3_js_1.Transaction {
    constructor(options, params) {
        const { feePayer } = options;
        const { associatedTokenAddress, owner, tokenMint } = params;
        super(options);
        this.add(new web3_js_1.TransactionInstruction({
            keys: [
                { pubkey: feePayer, isSigner: true, isWritable: true },
                { pubkey: associatedTokenAddress, isSigner: false, isWritable: true },
                { pubkey: owner !== null && owner !== void 0 ? owner : feePayer, isSigner: false, isWritable: false },
                { pubkey: tokenMint, isSigner: false, isWritable: false },
                { pubkey: web3_js_1.SystemProgram.programId, isSigner: false, isWritable: false },
                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                { pubkey: web3_js_1.SYSVAR_RENT_PUBKEY, isSigner: false, isWritable: false },
            ],
            programId: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            data: buffer_1.Buffer.from([]),
        }));
    }
}
exports.CreateAssociatedTokenAccount = CreateAssociatedTokenAccount;
//# sourceMappingURL=createAssociatedTokenAccount.js.map